import { Check, RotateCcw } from "lucide-react";
import bchannelLogo from "../../../logo.png";
import { LoadingRaccoon } from "./primitives";

export type SaveState = "saved" | "unsaved" | "saving" | "conflict" | "error";

export function SaveIndicator({ state }: { state: SaveState }) {
  const content = {
    saved: (
      <>
        <Check size={13} /> Draft saved
      </>
    ),
    saving: (
      <>
        <LoadingRaccoon size={16} /> Saving…
      </>
    ),
    unsaved: <>Unsaved changes</>,
    conflict: (
      <>
        <RotateCcw size={13} /> Newer version exists
      </>
    ),
    error: <>Couldn’t save</>,
  }[state];
  return <span className={`save-state ${state}`}>{content}</span>;
}

export function AccessRecovery({ signedIn }: { signedIn: boolean }) {
  return (
    <main className="access-recovery-screen">
      <section className="access-recovery">
        <header>
          <img src={bchannelLogo} alt="" />
          <strong>bChannel</strong>
        </header>
        <div>
          <h1>{signedIn ? "This message isn’t available" : "Sign in to keep going"}</h1>
          <p>
            {signedIn
              ? "It may have been deleted, or it belongs to another Slack account. Your other drafts are still on your home page."
              : "Slack links expire for safety. Sign in and bChannel will reopen every draft and sent message that belongs to you."}
          </p>
          <div className="access-recovery-actions">
            <a className="access-recovery-primary" href={signedIn ? "/" : "/auth/slack"}>
              {signedIn ? "Back to your messages" : "Sign in with Slack"}
            </a>
            {!signedIn && <a href="/">Go to bChannel</a>}
          </div>
        </div>
      </section>
    </main>
  );
}

export function BannedState() {
  return (
    <main className="access-recovery-screen">
      <section className="access-recovery banned-state">
        <header>
          <img src={bchannelLogo} alt="" />
          <strong>bChannel</strong>
        </header>
        <div>
          <h1>Sorry, you’re banned :ban:</h1>
        </div>
      </section>
    </main>
  );
}
